import { useTranslation } from '@fareye/common'
import { L, Marker, Popup } from '@fareye/ui'
import { isEmpty, isNullUndefinedAndEmpty } from '@fareye/utils'
import React from 'react'
import { TripInfoWindow } from '../../../components/Map/TripInfoWindow'
import { VehicleInfoWindow } from '../../../components/Map/VehicleInfoWindow'
import { renderToStaticMarkup } from 'react-dom/server'
import { Plane, Rail, Ship, Truck } from '../../../style/styled'

export const CurrentLocationMarker = ({
  moveMarker,
  histories,
  location,
  trip
}: any) => {
  const { t } = useTranslation()

  const { transportMode = 'road' } =  trip

  let tptMode: any = undefined
    if (transportMode === 'air') {
      tptMode = Plane
    } else if (transportMode === 'ocean') {
      tptMode = Ship
    } else if (transportMode === 'road') {
      tptMode = Truck
    } else if (transportMode === 'rail') {
      tptMode = Rail
    } else {
      tptMode = Truck
    }
    const iconMarkup = (Component: any) =>
      renderToStaticMarkup(
        <Component size={25}/>
      )

    const vehicleMarkerIcon = L.divIcon({
        html: iconMarkup(tptMode),
        className: 'in-plant-vehicle-marker',
        iconAnchor: [12.5, 12.5],
        iconSize: [25, 25]
      })

  const [latLngObject, setLatLngObject] = React.useState({
    latLng: { lat: location?.latitude, lng: location?.longitude },
    latLngIndex: 0
  })

  const getLatLongObj: any = () => {
    const historyLength = histories.length
    if (historyLength && latLngObject.latLngIndex !== historyLength - 1) {
      const index = latLngObject.latLngIndex + 1
      return {
        latLng: {
          lat: histories[index].latitude,
          lng: histories[index].longitude
        },
        latLngIndex: index
      }
    } else if (historyLength - 1 === latLngObject.latLngIndex) {
      return {
        latLng: { lat: histories[0].latitude, lng: histories[0].longitude },
        latLngIndex: 0
      }
    }
  }

  React.useEffect(() => {
    if (!moveMarker && location?.latitude && location?.longitude) {
      setLatLngObject({
        latLng: { lat: location.latitude, lng: location.longitude },
        latLngIndex: 0
      })
    }
  }, [location?.latitude, location?.longitude])

  React.useEffect(() => {
    let timeoutID: any = 0
    if (moveMarker && history.length) {
      timeoutID = setTimeout(() => {
        // updates position every 1 sec
        setLatLngObject(getLatLongObj())
      }, 1000)
    }
    return () => {
      clearTimeout(timeoutID)
    }
  }, [latLngObject])

  return (
    <>
      {!isEmpty(histories) &&
        location && !isEmpty(location) &&
        latLngObject.latLng.lat != null && latLngObject.latLng.lng != null &&
        isFinite(Number(latLngObject.latLng.lat)) && isFinite(Number(latLngObject.latLng.lng)) && (
        <Marker
          position={L.latLng(latLngObject.latLng.lat, latLngObject.latLng.lng)}
          icon={ vehicleMarkerIcon }
        >
          <Popup minWidth={149}>
            {trip && <TripInfoWindow data={trip} />}
            <hr />
            {location && <VehicleInfoWindow data={location} />}
          </Popup>
        </Marker>
      )}
    </>
  )
}
